"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = ChevronLeftLarge;
var _ChevronLeftLarge = require("@adobe/react-spectrum-ui/dist/ChevronLeftLarge.js");
var _icon = require("@react-spectrum/icon");
var _react = _interopRequireDefault(require("react"));
function ChevronLeftLarge(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.UIIcon, props, /*#__PURE__*/_react.default.createElement(_ChevronLeftLarge.ChevronLeftLarge, null));
}